import { render, staticRenderFns } from "./instituicoes_lista.vue?vue&type=template&id=31d81a42&"
import script from "./instituicoes_lista.vue?vue&type=script&lang=js&"
export * from "./instituicoes_lista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports